module.exports = function () {
    // open popup
    if ( document.querySelector(".case-study-button") ) {
        const buttons = document.querySelectorAll(".case-study-button");
        const popup = document.querySelector(".popup");

        buttons.forEach(btn => {
            btn.addEventListener("click", (e) => {
                e.preventDefault();

                const url = btn.getAttribute('href');
                popup.classList.add("-translate-y-full");
                document.body.classList.add("overflow-hidden");

                setTimeout(() => {
                    const options = {
                        introPage: window.location.href,
                        returnPage: window.location.href,
                        action: "open",
                    }

                    window.sessionStorage.setItem("popup", JSON.stringify(options));

                    window.location = url;
                }, 1000);
            })
        })
    }

    if ( document.querySelector(".single-case-study-button") ) {
        const buttons = document.querySelectorAll(".single-case-study-button");

        buttons.forEach(btn => {
            btn.addEventListener("click", (e) => {
                e.preventDefault();
                const options = JSON.parse(window.sessionStorage.getItem("popup"));

                if ( options ) {
                    options.returnPage = window.location.origin + '/portfolio';
                    window.sessionStorage.setItem("popup", JSON.stringify(options));
                }

                window.location = btn.getAttribute("href");
            })
        })
    }

    // close popup
    if ( document.querySelector(".case-study-popup-close") ) {
        const btn = document.querySelector(".case-study-popup-close");
        const popup = document.querySelector(".popup");

        btn.addEventListener("click", (e) => {
            e.preventDefault();

            popup.style.display = "block";
            window.scrollTo({top: 0, behavior: "smooth"});
            document.body.classList.add("overflow-hidden");
            const options = JSON.parse(window.sessionStorage.getItem("popup"));

            if ( options ) {
                options.action = "back";
                window.sessionStorage.setItem("popup", JSON.stringify(options));
            }

            setTimeout(() => {
                setTimeout(() => {
                    const section = document.querySelector(".intro-case-study");

                    if ( section ) {
                        section.querySelectorAll(".container").forEach(c => {
                            c.classList.add("transition-opacity", "duration-500");
                            c.style.opacity = 0;
                            document.querySelector(".header").classList.add("transition-opacity", "duration-500", "opacity-0");
                        });
                    }
                })

                setTimeout(() => {
                    if ( options?.introPage === options?.returnPage ) {
                        history.back();
                    }
                    else if ( options?.introPage !== options?.returnPage ) {
                        window.location = options.returnPage;
                    }
                    else {
                        document.location.href = "/portfolio";
                    }
                }, 1000);
            }, (window.innerHeight < window.scrollY) ? 600 : 0)
        })
    }
}